import React from 'react';
import { Link } from 'react-router-dom';
import { TModalState } from 'modules/types';
import { ERoute } from 'enums/route.enum';
import { Modal, Button } from 'antd';

type TLoginRequiredMoalProps = {
  modalState: TModalState;
  setModalState: React.Dispatch<React.SetStateAction<TModalState>>;
  nextPath: string;
};

const LoginRequiredModal = ({ modalState, setModalState, nextPath }: TLoginRequiredMoalProps) => {
  const handleCancel = () => {
    setModalState({ visible: false });
  };
  return (
    <Modal
      visible={modalState.visible}
      centered={true}
      maskClosable={true}
      closable={true}
      width={450}
      onCancel={handleCancel}
      title={
        <div style={{ marginTop: '20px' }}>
          <span
            style={{
              fontSize: '1.75rem',
              fontWeight: 'bolder',
            }}
          >
            로그인
          </span>
        </div>
      }
      footer={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Link to={`${ERoute.UserSignup}?next=${nextPath}`}>
            <Button>회원가입</Button>
          </Link>
          <Link to={`${ERoute.UserLogin}?next=${nextPath}`}>
            <Button className='ant-btn-primary'>로그인</Button>
          </Link>
        </div>
      }
    >
      <div>로그인 후에 이용이 가능합니다</div>
    </Modal>
  );
};

export default LoginRequiredModal;
